export { default as ProductInformation } from './productInformation'


// WEBPACK FOOTER //
// ./src/components/product/index.js